exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tabla_serie {\n    height: 352px !important;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n/* table {\n    \n    border-spacing: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\ntbody, thead tr { display: block; }\n\ntbody {\n    height: 300px;\n    \n} */\n/* \ntbody td, thead th {\n    width: 377.5px;\n}\ntbody td:first-child, thead th:first-child {\n    width: 100px;\n}\n\ntbody td:last-child {\n    width: 89px;\n}\n\ntbody td::last-child:before {\n    width: 89px;\n}\n\ntbody td::last-child:after {\n    width: 73px;\n}\n\n\nthead th:last-child {\n    width: 89px; \n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/modals/serie-ingreso-modal/serie-ingreso-modal.component.css
// module id = ../../../../../src/app/components/modals/serie-ingreso-modal/serie-ingreso-modal.component.css
// module chunks = main